import { render, staticRenderFns } from "./BaseShadowCard.vue?vue&type=template&id=1f9798bc&"
import script from "./BaseShadowCard.vue?vue&type=script&lang=js&"
export * from "./BaseShadowCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseShadowCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports